import React, { useEffect, useState } from 'react';
import ColorModel from './models/ColorModel';

function DeleteColor({ ColorData }) {
  const [selectedColor, setSelectedColor] = useState(new ColorModel());

  useEffect(() => {
    setSelectedColor(ColorData);
  }, [ColorData]);

  return (
    <div className="text-left px-2 pb-0">
      <h6>Following color will be deleted and cannot be recovered:</h6>
      <ul>
        <li>
          <b>Color Name:</b> {selectedColor.ColorName}
        </li>
        <li>
          <b>Color Code:</b> {selectedColor.ColorCode || 'N/A'}
        </li>
        <li>
          <b>Description:</b> {selectedColor.Description || 'N/A'}
        </li>
      </ul>
      <div id="DeleteColorDetails" hidden>
        {JSON.stringify(selectedColor)}
      </div>
    </div>
  );
}

export default DeleteColor;
